import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {LanguageService} from "../services/language.service";
import {TokenService} from "../services/token.service";

export const languageGuard: CanActivateFn = async () => {
  const languageService = inject(LanguageService);
  const tokenService = inject(TokenService);

  if (tokenService.hasToken()) {
    return true;
  }

  return await languageService.init();
};
